module.exports = __webpack_public_path__ + "img/ebook-udn.6f81df7e.png";